import { useLocation, Link } from 'react-router-dom'
import { useEffect, useRef } from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react'
import { trackUmami } from '@/lib/tracking'

export default function ErrorPage() {
  const location = useLocation()
  const error = location.state?.error || 'Ocorreu um erro inesperado'

  const errorTrackedRef = useRef(false)
  useEffect(() => {
    if (errorTrackedRef.current) return
    errorTrackedRef.current = true
    trackUmami('Erro no Checkout', { erro: error })
  }, [error])

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-rose-50 dark:from-red-950/20 dark:to-rose-950/20 p-4 py-12">
      <div className="mx-auto max-w-md">
        <Card>
          <CardHeader className="text-center">
            <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-100 dark:bg-red-900/20">
              <XCircle className="h-10 w-10 text-red-600 dark:text-red-400" />
            </div>
            <CardTitle className="text-red-900 dark:text-red-100">
              Erro no Checkout
            </CardTitle>
            <CardDescription>{error}</CardDescription>
          </CardHeader>

          <CardContent className="space-y-4">
            <div className="rounded-lg bg-muted p-4">
              <h4 className="mb-2 font-semibold text-sm">O que fazer agora?</h4>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li className="flex gap-2">
                  <span>•</span>
                  <span>Verifique seus dados e tente novamente</span>
                </li>
                <li className="flex gap-2">
                  <span>•</span>
                  <span>Tente outro método de pagamento</span>
                </li>
                <li className="flex gap-2">
                  <span>•</span>
                  <span>Entre em contato com nosso suporte</span>
                </li>
              </ul>
            </div>

            <div className="flex flex-col gap-2">
              <Button onClick={() => window.location.reload()} className="w-full">
                <RefreshCw className="mr-2 h-4 w-4" />
                Tentar Novamente
              </Button>

              <Button variant="outline" className="w-full" asChild>
                <Link to="/">
                  <ArrowLeft className="mr-2 h-4 w-4" />
                  Voltar ao Início
                </Link>
              </Button>
            </div>

            <div className="text-center">
              <p className="text-sm text-muted-foreground">
                Precisa de ajuda?{' '}
                <a
                  href="mailto:suporte@slac.com.br"
                  className="font-medium text-primary hover:underline"
                >
                  Fale com o suporte
                </a>
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
